export default __webpack_public_path__ + "static/media/locked.d060c403.svg";